/* unplugin-vue-components disabled */import script from "./selectVoice.vue?vue&type=script&lang=ts&setup=true"
export * from "./selectVoice.vue?vue&type=script&lang=ts&setup=true"

import "./selectVoice.vue?vue&type=style&index=0&id=a6387e96&lang=scss&scoped=true"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6387e96"]])

export default __exports__